import { render, staticRenderFns } from "./Aiexp.vue?vue&type=template&id=187babd8"
import script from "./Aiexp.vue?vue&type=script&lang=js"
export * from "./Aiexp.vue?vue&type=script&lang=js"
import style0 from "./Aiexp.vue?vue&type=style&index=0&id=187babd8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports